import React, { ReactNode, useEffect, useState } from 'react';
import { ControllerStateAndHelpers } from 'downshift';
import {
	IDropdownItem,
	IGetItemDisplayValue,
	IGetItemKey,
} from '../../DropdownList';
import MultiSelectDropdownList from '../../MultiselectDropdownList/MultiSelectDropdownList';
import { MultiSelectMain } from '../MultiSelectMain/MultiSelectMain';

interface IMultiSelectRootProps
	extends ControllerStateAndHelpers<IDropdownItem> {
	getItemDisplayValue: IGetItemDisplayValue;
	getItemKey: IGetItemKey;
	items: IDropdownItem[];
	initialSelectedItems?: IDropdownItem[];
	innerRef: React.RefObject<HTMLDivElement>;
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	disabled?: boolean;
	invalid?: boolean;
	className?: string;
	placeholder?: string;
	ariaLabel?: string;
	placeholderAsLabel?: boolean;
	icon?: ReactNode;
	onChange: (selectedItems: IDropdownItem[]) => void;
}

export function MultiSelectRoot(props: IMultiSelectRootProps) {
	const {
		getToggleButtonProps,
		getItemDisplayValue,
		getInputProps,
		getMenuProps,
		getItemProps,
		getItemKey,
		innerRef,
		selectedItem,
		className,
		disabled,
		invalid,
		ariaLabel,
		placeholder,
		items,
		initialSelectedItems,
		placeholderAsLabel,
		icon,
		isOpen,
		setIsOpen,
		onChange,
	} = props;

	const dropdownProps = {
		getItemDisplayValue,
		getMenuProps,
		getItemProps,
		getItemKey,
		items,
		initialSelectedItems,
		onChange,
	};

	const [selectedItems, setSelectedItems] = useState<IDropdownItem[]>(
		initialSelectedItems || [],
	);

	useEffect(() => {
		if (initialSelectedItems) {
			setSelectedItems(initialSelectedItems);
		}
	}, [initialSelectedItems]);

	const handleMultiSelectClick = () => {
		setIsOpen((prev) => !prev);
	};

	return (
		<div ref={innerRef} className={className}>
			<MultiSelectMain
				getInputProps={getInputProps}
				getToggleButtonProps={(options) =>
					getToggleButtonProps({
						...options,
						onClick: handleMultiSelectClick,
					})
				}
				getItemDisplayValue={getItemDisplayValue}
				selectedItem={selectedItem}
				disabled={disabled}
				invalid={invalid}
				ariaLabel={ariaLabel}
				placeholder={placeholder}
				isOpen={isOpen}
				placeholderAsLabel={placeholderAsLabel}
				icon={icon}
				multiSelectCount={selectedItems.length}
			/>
			<MultiSelectDropdownList
				{...dropdownProps}
				isOpen={isOpen}
				selectedItems={selectedItems}
				setSelectedItems={setSelectedItems}
			/>
		</div>
	);
}
